import Model from '../../ModelBinding/Model';
import VoucherCollection from './VoucherCollection';
import dayjs from 'dayjs';
import OrganizationCollection from '../Organization/OrganizationCollection';

export default class Voucher extends Model {
  public code?: string;
  public value?: number;
  public currency?: string;
  public reason?: string;
  public uses?: number;
  public max_uses?: number;
  public max_uses_user?: number;
  public is_fixed?: boolean;
  public comment?: string;
  public starts_at?: dayjs.Dayjs;
  public expires_at?: dayjs.Dayjs;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public organizations?: OrganizationCollection;

  bind() {
    this.code = this.getStringAttribute('code');
    this.value = this.getIntAttribute('value');
    this.currency = this.getStringAttribute('currency');
    this.reason = this.getStringAttribute('reason');
    this.uses = this.getIntAttribute('uses');
    this.max_uses = this.getIntAttribute('max_uses');
    this.max_uses_user = this.getIntAttribute('max_uses_user');
    this.is_fixed = this.getBooleanAttribute('is_fixed');
    this.comment = this.getStringAttribute('comment');
    this.starts_at = this.getDateAttribute('starts_at');
    this.expires_at = this.getDateAttribute('expires_at');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.organizations = this.getRelationCollection(
      'organizations',
      OrganizationCollection,
    ) as OrganizationCollection;
  }

  static getCollection() {
    return VoucherCollection;
  }
}
